import actions from '../action/fenqile'
import CONSTANT from '../constant/fenqile'

export default {
  actions,
  state: {
    totalCredit: '',
    profit: '',
  },
  getters: {

  },
  mutations: {
    [CONSTANT.FENQILE_BINDFENQILEACCOUNT_SUCCESS](state, data) {

    },
    [CONSTANT.FENQILE_BINDFENQILEACCOUNT_ERROR](state, e) {},
    [CONSTANT.FENQILE_FENQILELOGIN_SUCCESS](state, data) {

    },
    [CONSTANT.FENQILE_FENQILELOGIN_ERROR](state, e) {},
    [CONSTANT.FENQILE_GETFENQILEPAYURL_SUCCESS](state, data) {

    },
    [CONSTANT.FENQILE_GETFENQILEPAYURL_ERROR](state, e) {

    },
    [CONSTANT.FENQILE_FENQILEPAYTRIAL_SUCCESS](state, data) {
      state.totalCredit = data.totalCredit
      state.profit = data.profit
    },
    [CONSTANT.FENQILE_FENQILEPAYTRIAL_ERROR](state, e) {

    },
    [CONSTANT.FENQILE_GETAPPTOKEN_SUCCESS] (state, data) {

    },
    [CONSTANT.FENQILE_GETAPPTOKEN_ERROR] (state, e) {
    },
        /*yeoman-template-point-1*/

  },
}
